import React, { FC } from 'react';

import ParseTextWithBreaklines from 'utils/ParseTextWithBreaklines';

import ImgHome from 'assets/img/home.svg';
import { useHistory } from 'react-router-dom';
import texts from '../../texts';

import {
  ContentWrapper,
  InitialContainer,
  CreateApprovalButton,
} from './styles';

const InitialScreen: FC = () => {
  const history = useHistory();
  const editData = () => {
    history.push('/aprovacao-automatica/create');
  };

  return (
    <InitialContainer>
      <img src={ImgHome} alt="Ilustração aprovação automatica" />
      <ContentWrapper>
        <h3>{texts.title}</h3>
        <ParseTextWithBreaklines text={texts.firstParagraph} />
        <ParseTextWithBreaklines text={texts.secondParagraph} />
        <ParseTextWithBreaklines text={texts.thirdParagraph} />

        <CreateApprovalButton onClick={(): void => editData()}>
          {texts.buttonText}
        </CreateApprovalButton>
      </ContentWrapper>
    </InitialContainer>
  );
};

export default InitialScreen;
